var _path, _path2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAirtableImage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.8646 0.978135L1.88395 22.9546C1.60304 23.2347 1.38014 23.5675 1.22806 23.934C1.07597 24.3005 0.997681 24.6934 0.997681 25.0902C0.997681 25.487 1.07597 25.8799 1.22806 26.2464C1.38014 26.6129 1.60304 26.9457 1.88395 27.2258L23.8646 49.2021C25.0464 50.3835 26.955 50.3835 28.1366 49.2021L37.353 39.9877C38.4113 38.9296 38.4113 37.214 37.353 36.156C36.2946 35.0978 34.5788 35.0978 33.5205 36.156L26.5337 43.1412C26.2396 43.4353 25.7932 43.4353 25.499 43.1412L7.94585 25.5917C7.65172 25.2976 7.65172 24.8513 7.94585 24.5572L25.499 7.00752C25.7932 6.7136 26.2396 6.7136 26.5337 7.00752L33.5205 13.9929C34.5788 15.0511 36.2946 15.0511 37.353 13.9929C38.4113 12.9347 38.4113 11.2193 37.353 10.1612L28.1376 0.947979C26.9511 -0.208122 25.0417 -0.198723 23.8646 0.978135Z",
    fill: "url(#paint0_linear_3574_18182)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8646 0.978038L1.88395 22.9545C1.60304 23.2346 1.38014 23.5674 1.22806 23.9339C1.07597 24.3004 0.997681 24.6933 0.997681 25.0901C0.997681 25.4869 1.07597 25.8798 1.22806 26.2463C1.38014 26.6128 1.60304 26.9456 1.88395 27.2257L23.8646 49.202C25.0464 50.3834 26.955 50.3834 28.1366 49.202L37.353 39.9876C38.4113 38.9295 38.4113 37.2139 37.353 36.1559C36.2946 35.0977 34.5788 35.0977 33.5205 36.1559L26.5337 43.1411C26.2396 43.4352 25.7932 43.4352 25.499 43.1411L7.94585 25.5916C7.65172 25.2975 7.65172 24.8512 7.94585 24.5571L25.499 7.00743C26.2313 6.37572 27.4265 5.09626 29.1811 4.79666C30.4852 4.57441 31.911 5.06395 33.4584 6.26528L28.1378 0.947687C26.9511 -0.208219 25.0419 -0.19882 23.8646 0.978038Z",
    fill: "url(#paint1_linear_3574_18182)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4806 34.112C40.5389 35.1702 42.2548 35.1702 43.3131 34.112L50.1114 27.3152C50.3923 27.0351 50.6152 26.7023 50.7673 26.3358C50.9194 25.9693 50.9977 25.5764 50.9977 25.1796C50.9977 24.7828 50.9194 24.3899 50.7673 24.0234C50.6152 23.6569 50.3923 23.3241 50.1114 23.044L43.254 16.212C42.1931 15.1552 40.4767 15.1567 39.4178 16.2155C38.3594 17.2737 38.3594 18.9891 39.4178 20.0472L44.0493 24.6779C44.3434 24.972 44.3434 25.4183 44.0493 25.7124L39.4806 30.2802C38.4223 31.3384 38.4223 33.054 39.4806 34.112Z",
    fill: "url(#paint2_linear_3574_18182)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1106 31.1336C29.3884 31.1336 32.0455 28.477 32.0455 25.2C32.0455 21.9229 29.3884 19.2663 26.1106 19.2663C22.8329 19.2663 20.1757 21.9229 20.1757 25.2C20.1757 28.477 22.8329 31.1336 26.1106 31.1336Z",
    fill: "url(#paint3_linear_3574_18182)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3574_18182",
    x1: 24.068,
    y1: 0.0881341,
    x2: 44.9632,
    y2: 12.8407,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4285EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2EC7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3574_18182",
    x1: 26.8698,
    y1: 0.088013,
    x2: 16.5408,
    y2: 53.4388,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#29CDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3786,
    stopColor: "#148EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A60FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3574_18182",
    x1: 47.2473,
    y1: 12.8924,
    x2: 33.8117,
    y2: 33.8913,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA816E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41473,
    stopColor: "#F74A5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F51D2C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3574_18182",
    x1: 28.2624,
    y1: 15.0308,
    x2: 23.7907,
    y2: 32.9074,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA8E7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51264,
    stopColor: "#F74A5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F51D2C"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirtableImage);
export default __webpack_public_path__ + "static/media/airtable-image.44edf349da05e929f9608aa8e48ff773.svg";
export { ForwardRef as ReactComponent };